import { Skeleton, styled } from "@mui/material";
import { Card } from "@volt_developers/components";

export interface CardCustomerNameItemLoadingStateProps {
  label: string;
  "data-testid"?: string;
}

export function CardCustomerNameItemLoadingState({
  label,
  "data-testid": dataTestId,
}: CardCustomerNameItemLoadingStateProps) {
  return (
    <Card.Item data-testid={dataTestId} label={label}>
      <Wrapper>
        <Skeleton sx={{ width: WIDTH, height: HEIGHT }} />
      </Wrapper>
    </Card.Item>
  );
}

const WIDTH = 294;

const HEIGHT = 14;

const Wrapper = styled("div")(({ theme }) => ({
  margin: theme.spacing(1, 0),
}));
